import axios from "../../../core/api/http-common";

const ON_CREATE_CHALLENGE = "/challenges/create";
const ON_GEY_CHALLENGES_BY_USER = "/challenges/get/by/user/with/pagination";
export function onCreateChallenge(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_CREATE_CHALLENGE, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengesByUserIdWithPagination(
  axiosPrivate,
  data,
  signal,
) {
  const _data = {
    is_set: data?.is_set,
    inscription_id: data?.inscription_id,
    rows_per_page: data?.rows_per_page,
    current_page: data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GEY_CHALLENGES_BY_USER, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// Host
const ON_GET_DETAILS_CHALLENGE_BY_INSCRIPTION_ID_AND_CHALLENGE_ID =
  "/challenges/get/details/by/inscription_id/and/challenge_id";
const ON_GET_CHALLENGE_JOINING_REQUESTS_BY_CHALLENGE_ID =
  "/challenges/get/joining/requests/by/challenge_id";
const ON_PROCESS_CHALLENGE_JOINING_REQUESTS =
  "/challenges/process/joining/request";
const ON_GET_CHALLENGE_REPORTS = "/challenges/get/reports";
const ON_PROCESS_REVOKE_CHALLENGE_JOINING_REQUESTS =
  "/challenges/process/revoke/joining/request";
const ON_HOSTING_PROCESS_CHALLENGE_STATUS =
  "/challenges/hosting/process/status";
export function onGetChallengeDetailsByInscriptionIdAndChallengeId(
  axiosPrivate,
  data,
  signal,
) {
  const _data = {
    inscription_id: data?.inscription_id,
    challenge_id: data?.challenge_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_DETAILS_CHALLENGE_BY_INSCRIPTION_ID_AND_CHALLENGE_ID, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeJoiningRequestsByChallengeId(axiosPrivate, data) {
  const _data = {
    challenge_id: data?.challenge_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_JOINING_REQUESTS_BY_CHALLENGE_ID, {
        params: _data,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetChallengeReports(axiosPrivate, data, signal) {
  const _data = {
    challenge_id: data?.challenge_id,
    report_type: data?.report_type,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_REPORTS, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onProcessChallengeJoiningRequest(axiosPrivate, data) {
  const _data = {
    request_id: data?.request_id,
    is_authorized: data?.is_authorized,
    process_request_dates: data?.process_request_dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_PROCESS_CHALLENGE_JOINING_REQUESTS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onProcessRevokeChallengeJoiningRequest(axiosPrivate, data) {
  const _data = {
    request_id: data?.request_id,
    process_request_dates: data?.process_request_dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_PROCESS_REVOKE_CHALLENGE_JOINING_REQUESTS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onProcessChallengeStatus(axiosPrivate, data) {
  const _data = {
    inscription_id: data?.inscription_id,
    challenge_id: data?.challenge_id,
    challenge_code: data?.challenge_code,
    current_status: data?.current_status,
    request_dates: data?.request_dates,
  };

  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .patch(ON_HOSTING_PROCESS_CHALLENGE_STATUS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
const ON_HOSTING_GET_CHALLENGE_CURRENT_QUESTION =
  "/challenges/hosting/get/current/question/state";
const ON_HOSTING_LAUNCH_QUESTION = "/challenges/hosting/launch/question";
export function onHostingGetChallengeCurrentQuestion(
  axiosPrivate,
  data,
  signal,
) {
  const _data = {
    challenge_id: data?.challenge_id,
    question_index: data?.question_index,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_HOSTING_GET_CHALLENGE_CURRENT_QUESTION, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onHostingLaunchQuestion(axiosPrivate, data) {
  const _data = {
    question_id: data?.question_id,
    is_launched: data?.is_launched,
    request_dates: data?.request_dates,
  };

  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .patch(ON_HOSTING_LAUNCH_QUESTION, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Player Joining
const ON_REQUEST_JOINING_CHALLENGE = "/challenges/request/joining";
const ON_GET_REQUEST_JOINING_PROCESS_STATE =
  "/challenges/request/joining/get/process/state";
const ON_UPDATE_PLAYER_NICKNAME =
  "/challenges/request/joining/update/player/nickname";
export function onRequestJoiningChallenge(axiosPrivate, data) {
  const _data = {
    inscription_id: data?.inscription_id,
    challenge_code: data?.challenge_code,
    request_dates: data?.request_dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_REQUEST_JOINING_CHALLENGE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetRequestJoiningProccessedState(axiosPrivate, data, signal) {
  const _data = {
    inscription_id: data?.inscription_id,
    challenge_id: data?.challenge_id,
  };

  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_REQUEST_JOINING_PROCESS_STATE, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onUpdatePlayerNickname(axiosPrivate, data) {
  const _data = {
    request_id: data?.request_id,
    player_name_joined: data?.player_name_joined,
    request_dates: data?.request_dates,
  };

  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_UPDATE_PLAYER_NICKNAME, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
const ON_CHALLENGE_WAITING_ROOM = "/challenges/on/waiting/room";
export function onWaitingRoom(axiosPrivate, data, signal) {
  const _data = {
    request_id: data?.request_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_CHALLENGE_WAITING_ROOM, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// export function onGetJoinedTeams(data, signal) {
//   const _data = {
//     inscription_id: data?.inscription_id,
//     challenge_code: data?.challenge_code,
//     request_id: data?.request_id,
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .get(CHALLENGES + "/on/joined/teams", {
//         params: _data,
//         signal: signal,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// export function onRequestingJoiningTeam(data) {
//   const _data = {
//     inscription_id: data?.inscription_id,
//     request_id: data?.request_id,
//     is_confirmed: data?.is_confirmed,
//     request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
//   };
//   return new Promise(async (resolve, reject) => {
//     await axios
//       .post(CHALLENGES + "/request/joining/team", _data, {
//         headers: { "Content-Type": "application/json" },
//         withCredentials: true,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
// Hosting Quiz Challenge
// The function allow to get the current/next question or one by one question to answer during the test
const ON_GET_CHALLENGE_CURRENT_QUESTION =
  "/challenges/hosting/get/current/question";
export function onGetQuizChallengeCurrentQuestion(axiosPrivate, data, signal) {
  const _data = {
    challenge_id: data?.challenge_id,
    request_id: data?.request_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_CHALLENGE_CURRENT_QUESTION, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// The function allow to answer the current/next question during the test
const ON_ANSWERING_CHALLENGE_CURRENT_QUESTION =
  "/challenges/hosting/answering/current/question";
export function onAnsweringQuizChallengeCurrentQuestion(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_ANSWERING_CHALLENGE_CURRENT_QUESTION, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
